import React from 'react';
import { Modal, Box, IconButton, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import JunoButton from './JunoButton';
import { useJunoCommonFunctions } from '../../../client/Juno/helpers';

const TransactionCommonModal = ({
    open,
    onClose,
    onBack,
    heading,
    children,
    bottomButtonText,
    onBottomButtonClick,
    showBackButton = false,
    showCloseIcon = true,
    disabled = false,
    loading = false,
    loadingText,
    childrenCss = {},
    error
}) => {
    const { useWindowWidth } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: windowWidth < 716 ? '100vw' : '90%',
        maxWidth: windowWidth < 716 ? '100vw' : 600,
        bgcolor: 'var(--common-modal-bg)',
        boxShadow: 24,
        borderRadius: windowWidth < 716 ? 0 : 2,
        p: 3,
        maxHeight: windowWidth < 716 ? '100vh' : '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'visible',
        ...(windowWidth < 716 && { height: '100vh' }),
    };
    return (
        <Modal open={Boolean(open)} onClose= {(action,reason)=> {  if (reason == 'backdropClick' && loading) return
         onClose(action)}} aria-labelledby="transaction-modal-title">
            <Box sx={style}>
                {/* Header */}
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} >
                    <Box display="flex" alignItems="center" >
                        {showBackButton && (
                            <IconButton onClick={onBack} sx={{ mr: 1, pl: 0 }}>
                                <ArrowBackIcon className="!text-primary text-xl font-semibold" />
                            </IconButton>
                        )}
                        <Typography
                            className="!text-primary text-xl font-semibold text-uppercase !font-inter"
                            variant="h6"
                            component="h2"
                            id="transaction-modal-title">
                            {heading}
                        </Typography>
                    </Box>
                    {showCloseIcon && (
                        <IconButton onClick={onClose} aria-label="close" data-e2e='confirm-close-button'>
                            <CloseIcon className="!text-primary" />
                        </IconButton>
                    )}
                </Box>

                {/* Body */}
                <Box sx={{ flex: 1, mb: 2, ...(childrenCss || {}), scrollbarWidth: 'none',  }} overflow={'auto'}  >{children}</Box>

                {/* Bottom Sticky Button */}
                {error &&   <p className="text-error text-sm my-1 font-normal font-Inter uppercase">{error}</p>}
                {bottomButtonText && (
                    <Box mt="auto">
                        <JunoButton
                            onClick={onBottomButtonClick}
                            disabled={disabled}
                            loading={loading}
                            dataE2e={bottomButtonText ? bottomButtonText.toLowerCase().replace(/\s+/g, '-') + '-button' : 'continue-btn'}>
                            {loading ? loadingText : bottomButtonText}
                        </JunoButton>
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

export default TransactionCommonModal;
